import RMSTransactionDetailContainer from "./RMSTransactionDetailContainer";
import RMSTransactionDetailStore from "./RMSTransactionDetailStore";

export default RMSTransactionDetailStore(RMSTransactionDetailContainer)